import { FC } from "react";
import styles from "./main.module.css";
import {format} from 'date-fns';

interface Data {
  name?: string;
  time?: string;
  date?: string;
}

export interface EventItemProps {
  data: Data | any;
}

const EventItem: FC<EventItemProps> = ({ data }) => {
  //console.log(data,'each event data')
  return (
    <main className={styles.main}>
      <div>
        <span>
          {format(new Date(data?.ExamPeriod?.StartDate), "dd/MM/yyyy")}
        </span>
      </div>

      <div>
        <span>{data?.ExamSubject?.SubjectCode}</span>
        <span>
          {format(new Date(data?.ExamPeriod?.StartDate), "hh:mm")}
        </span>
      </div>
    </main>
  );
};

export default EventItem;
